export default __webpack_public_path__ + "static/loading-d20b2446e111d818abeb64f12fd83060.png";